module.exports = "<div class=\"form-group\"\n     ng-switch=\"element.attributes.format\"\n>\n    <div ng-switch-when=\"header\">\n        <h1>{{ element.value.value }}</h1>\n    </div>\n    <div ng-switch-when=\"subheader\">\n        <h3>{{ element.value.value }}</h3>\n    </div>\n    <div ng-switch-when=\"paragraph\">\n        <p class=\"m-t\"\n           ng-bind-html=\"element.value.value | nl2br\"\n        ></p>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/js/directives/formElements/staticText/view.html
// module id = 945
// module chunks = 0